import { capitalize, lowerCase } from 'lodash'
import { useMemo } from 'react'

import { useAggregateLabel } from '~map-preview/states/boundaries'
import { LAYER_TYPES, useLayerType } from '~map-preview/states/layerType'
import { useTitle } from '~map-preview/states/legend'
import { MARKER_TYPES, useMarkerType } from '~map-preview/states/marker'

const defaultTitle = 'N/A'

export const useLegendTitle = () => {
  const layerType = useLayerType()
  const title = useTitle()
  const aggregateLabel = useAggregateLabel()
  const markerType = useMarkerType()

  const legendTitle = useMemo(() => {
    const prefix = title === 'count' ? 'Number of locations' : capitalize(title)

    if (!title) return defaultTitle

    if (layerType === LAYER_TYPES.HEXAGON) return prefix

    if (layerType === LAYER_TYPES.BOUNDARIES) {
      const postfix = lowerCase(aggregateLabel)
      return `${prefix} by ${postfix}`
    }

    if (
      layerType === LAYER_TYPES.MARKER &&
      markerType === MARKER_TYPES.CATEGORIES
    ) {
      return title
    }

    return defaultTitle
  }, [title, layerType, markerType, aggregateLabel])

  return legendTitle
}
